document.addEventListener('submit', async (event) => {
  const form = event.target.closest('[data-nokami-pairing]');
  if (!form) return;
  event.preventDefault();
  const button = form.querySelector('button[type="submit"]');
  const status = form.querySelector('[data-pair-status]');
  const drawer = document.querySelector('cart-drawer');
  button.disabled = true;
  status.textContent = '';
  try {
    const body = new FormData(form);
    body.append('sections', drawer?.getSectionsToRender ? drawer.getSectionsToRender().map(s => s.id).join(',') : 'cart-drawer,cart-icon-bubble');
    body.append('sections_url', window.location.pathname);
    const response = await fetch(form.action + '.js', { method: 'POST', body, headers: { Accept: 'application/json' } });
    const data = await response.json();
    if (!response.ok || data.status) throw new Error(data.description || status.dataset.error);
    if (drawer?.renderContents) {
      drawer.setActiveElement?.(button);
      drawer.classList.remove('is-empty');
      drawer.renderContents(data);
    } else window.location.assign(form.dataset.cartUrl);
  } catch (error) { status.textContent = error.message || status.dataset.error; }
  finally { button.disabled = false; }
});
document.addEventListener('click', async (event) => {
  const button = event.target.closest('[data-estimate-button]');
  if (!button) return;
  const box = button.closest('[data-shipping-estimator]');
  const zip = box.querySelector('[data-estimate-zip]');
  const state = box.querySelector('[data-estimate-state]');
  if (!state.reportValidity() || !zip.reportValidity()) return;
  const result = box.querySelector('[data-estimate-result]');
  button.disabled = true;
  result.textContent = box.dataset.loading;
  const params = new URLSearchParams({ 'shipping_address[country]': 'United States', 'shipping_address[province]': state.value, 'shipping_address[zip]': zip.value.trim() });
  const root = box.dataset.root.endsWith('/') ? box.dataset.root : box.dataset.root + '/';
  try {
    const prep = await fetch(root + 'cart/prepare_shipping_rates.json?' + params, { method: 'POST', headers: { Accept: 'application/json' } });
    if (!prep.ok) throw new Error();
    let data = null;
    for (let attempt = 0; attempt < 8 && !data; attempt++) {
      if (attempt) await new Promise(resolve => setTimeout(resolve, 1250));
      const response = await fetch(root + 'cart/async_shipping_rates.json?' + params, { headers: { Accept: 'application/json' } });
      if (!response.ok) throw new Error();
      data = await response.json();
    }
    if (!data) throw new Error();
    result.replaceChildren();
    const rates = data.shipping_rates || [];
    if (!rates.length) { result.textContent = box.dataset.none; return; }
    const list = document.createElement('ul');
    for (const rate of rates) {
      const item = document.createElement('li');
      const amount = new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: box.dataset.currency || 'USD' }).format(Number(rate.price));
      item.textContent = (rate.presentment_name || rate.name) + ': ' + amount;
      list.appendChild(item);
    }
    result.appendChild(list);
  } catch { result.textContent = box.dataset.error; }
  finally { button.disabled = false; }
});
